import React, { useEffect, useRef } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { api } from '@/lib/api';

/**
 * Short invite link landing — /r/:slug
 * Fires click tracking exactly once and redirects to /register?invite=:slug.
 * The useRef guard prevents double-tracking under React.StrictMode (dev).
 */
export default function InviteRedirect() {
  const { slug } = useParams();
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    if (slug) api.post(`/invitations/track/${slug}`).catch(() => {});
  }, [slug]);

  return <Navigate to={`/register?invite=${encodeURIComponent(slug || '')}`} replace />;
}
